export default __webpack_public_path__ + "static/media/fitnessband.d8d44c73.jfif";